module.exports = __webpack_public_path__ + "static/media/1POLICY14.a52cc155.jpg";